import { FullFileType } from '@/modules/FileList/types/FileList.type.ts';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';

export default (data: FullFileType): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'شناسه پرونده',
    value: data.order_id,
    dirLtr: true,
  },
  {
    type: 'tel',
    keyName: 'اعلام کننده',
    value: data.full_name,
    telephone: data.phone_number,
  },
  {
    type: 'default',
    keyName: 'آدرس بازدید',
    value: data.visit_location,
  },
];
